<template>
  <div class="component-lock row" v-if="locked">
    <div class="col-xs-12">
      <div class="alert alert-danger">
        <span>{{ lockStatus ? lockStatus : _('This item is currently being edited.') }}</span>
        <div class="lock-buttons" v-if="!readOnly">
          <button type="button" class="btn btn-default" v-if="cancel" v-on:click="cancelLock"><i class="fa fa-fw fa-unlock"></i> {{ _('Cancel') }}</button>
          <button type="button" class="btn btn-danger" v-on:click="forceLock"><i class="fa fa-fw fa-unlock"></i> {{ _('Release lock') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['locked', 'lockStatus', 'cancel', 'readOnly'],
  methods: {
    forceLock () {
      this.$emit('forceLock')
    },
    cancelLock () {
      this.$emit('cancel')
    }
  }
}
</script>